import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import userCompanyApi from '@/utils/userCompanyApi';
export function useCompany() {
  const dispatch = useDispatch();
  const {
    userInfo,
    companies,
    currentCompany
  } = useSelector(state => state);
  const [loading, setLoading] = useState(false);
  const getStoredCompanies = () => {
    try {
      const stored = localStorage.getItem('companies');
      if (stored && stored !== 'null') {
        const parsed = JSON.parse(stored);
        return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
      }
    } catch {
      // ignore
    }
    return null;
  };
  const getStoredCurrentCompanyId = () => {
    const id = localStorage.getItem('current_company_id');
    return id && id !== 'null' ? id : null;
  };
  const setStoredCurrentCompanyId = id => {
    localStorage.setItem('current_company_id', id);
  };
  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const userId = userInfo?.id;
      if (!userId) return;
      const response = await userCompanyApi.getUserCompanies(userId);
      const companyData = response.data?.data || response.data || [];
      localStorage.setItem('companies', JSON.stringify(companyData));
      dispatch({
        type: 'update-companies',
        payload: {
          companies: companyData
        }
      });
      const storedId = getStoredCurrentCompanyId();
      if (!storedId && companyData.length > 0) {
        setStoredCurrentCompanyId(companyData[0].id.toString());
        dispatch({
          type: 'update-currentCompany',
          payload: {
            currentCompany: companyData[0]
          }
        });
      } else if (storedId) {
        const selected = companyData.find(c => c.id === parseInt(storedId, 10)) || companyData[0];
        dispatch({
          type: 'update-currentCompany',
          payload: {
            currentCompany: selected
          }
        });
      }
    } catch {
      _Message.error('获取公司列表失败');
    } finally {
      setLoading(false);
    }
  };
  const initFromStorage = () => {
    const storedCompanies = getStoredCompanies();
    if (storedCompanies) {
      dispatch({
        type: 'update-companies',
        payload: {
          companies: storedCompanies
        }
      });
      const storedId = getStoredCurrentCompanyId();
      if (storedId) {
        const selected = storedCompanies.find(c => c.id === parseInt(storedId, 10)) || storedCompanies[0];
        setStoredCurrentCompanyId(selected.id.toString());
        dispatch({
          type: 'update-currentCompany',
          payload: {
            currentCompany: selected
          }
        });
      }
      return true;
    }
    return false;
  };
  const switchCompany = async companyId => {
    const userId = userInfo?.id;
    if (!userId) {
      _Message.error('用户信息不存在，请重新登录');
      return false;
    }
    try {
      await userCompanyApi.setCurrentCompany(userId, companyId);
      setStoredCurrentCompanyId(companyId.toString());
      const selected = (companies || []).find(c => c.id === companyId) || null;
      dispatch({
        type: 'update-currentCompany',
        payload: {
          currentCompany: selected
        }
      });
      return true;
    } catch {
      _Message.error('切换公司失败');
      return false;
    }
  };
  useEffect(() => {
    if (userInfo?.id) {
      if (!initFromStorage()) {
        fetchCompanies();
      }
    }
  }, [userInfo]);
  return {
    companies,
    currentCompany,
    loading,
    fetchCompanies,
    switchCompany
  };
}